/**
 * "The MCP server" overview — MCP section (ADR-0074).
 * Reconciled from apps/api/src/api/mcp + product/architecture/mcp-server.md.
 */
import type { DocPageContent } from '../types';

export const MCP_OVERVIEW_PAGE: DocPageContent = {
  slug: 'mcp',
  titleKey: 'docs.mcp.overview.title',
  descriptionKey: 'docs.mcp.overview.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.mcp.overview.lead' },

    { kind: 'heading', level: 2, id: 'who', textKey: 'docs.mcp.overview.who.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.overview.who.body' },

    { kind: 'heading', level: 2, id: 'url', textKey: 'docs.mcp.overview.url.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.overview.url.body' },
    { kind: 'code', language: 'text', code: 'https://mcp.syncanix.com/v1/<your-workspace>' },

    { kind: 'heading', level: 2, id: 'tester', textKey: 'docs.mcp.overview.tester.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.overview.tester.body' },

    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.mcp.overview.rollout.title',
      textKey: 'docs.mcp.overview.rollout.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.mcp.overview.next.connect.title',
          textKey: 'docs.mcp.overview.next.connect.text',
          to: { docSlug: 'mcp/connect' },
        },
        {
          titleKey: 'docs.mcp.overview.next.auth.title',
          textKey: 'docs.mcp.overview.next.auth.text',
          to: { docSlug: 'mcp/authentication' },
        },
      ],
    },
  ],
};
